import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import classNames from 'classnames';
import styles from './NextStepsCommon.module.scss'; // SCSS module

type NextStepsCommonProps = ComponentProps & {
  title?: string;
  subtitle?: string;
  description?: string;
  placeholderName?: string;
  anchorId?: string;
  className?: string;
};

const NextStepsCommon: React.FC<NextStepsCommonProps> = ({
  rendering,
  title = '',
  subtitle = '',
  description = '',
  placeholderName = '',
  anchorId = '',
  className,
}) => {
  return (
    <div
      id={anchorId}
      className={classNames('background-blue-grey p-4', styles.printstyle, className)}
    >
      {title && <h2>{title}</h2>}

      {subtitle && <h3 className={classNames('h4', { 'mt-5': !!title })}>{subtitle}</h3>}

      {description && <p className={`body-default mt-3`}>{description}</p>}

      <div className="mt-3">
        <Placeholder name={placeholderName} rendering={rendering} sidebar={false} />
      </div>
    </div>
  );
};

export default NextStepsCommon;
